// When a page is rendered using SSR, the ssr renderer will send initial markup
// with:
//
// window.ssr = true;
export default !!window.ssr;
